import DefaultLink from '@/components/common/default/DefaultLink';
import { IndexBlogPostsCarouselProps } from '@/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import IndexBlogPostCard from './IndexBlogPostCard';

export default function IndexBlogPostsCarousel({
  title,
  blogPosts,
  browserLocale,
}: IndexBlogPostsCarouselProps) {
  const { translate: translateCommon } = useTypedTranslation<CommonEnum>('common');
  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-4 max-nine:tw-px-4">
        <h2 className="tw-relative tw-w-fit tw-font-plusJakartaSans tw-text-2xl tw-font-semibold tw-text-text max-nine:tw-text-lg">
          {title ?? translateCommon(CommonEnum['spiritory_magazine'])}
          <hr
            aria-hidden="true"
            className="tw-absolute tw-mt-1 tw-h-[5px] tw-w-[80%] tw-rounded-full tw-border-none tw-bg-custom-gold tw-opacity-100 max-nine:tw-h-[3px]"
          />
        </h2>
        <div className="tw-flex tw-items-center tw-justify-end">
          <DefaultLink
            href="/blog"
            className="tw-font-plusJakartaSans tw-text-base tw-font-semibold tw-text-textBlack max-nine:tw-text-sm"
          >
            {translateCommon(CommonEnum['view_more'])}
          </DefaultLink>
        </div>
      </div>
      <div className="tw-w-full max-nine:tw-pl-4">
        <Swiper
          breakpoints={{
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            552: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            694: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            856: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 30,
            },
          }}
          loop={false}
          className="tw-h-[450px]"
        >
          {blogPosts.map(blogPost => (
            <SwiperSlide
              key={blogPost.id}
              className="tw-h-[420px] tw-max-h-[420px] max-nine:tw-h-[395px] max-nine:tw-max-h-[395px]"
            >
              <IndexBlogPostCard blogPost={blogPost} browserLocale={browserLocale} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
